import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import Loader from '../lib/components/Loader';
import { NavLink } from 'react-router-dom';
import OverlayLoader from '../lib/components/OverlayLoader';
import bootstrapBundleMin from 'bootstrap/dist/js/bootstrap.bundle.min';

const PendingTrades = () => {
    const [pendingTrades, setPendingTrades] = useState([]);
    const [selectedTrade, setSelectedTrade] = useState(null);
    const [loading, setLoading] = useState(true);
    const [modalLoading, setModalLoading] = useState(false);

    const fetchPendingTrades = () => {
        setLoading(true);
        api.get('/api/v1/transactions/trades/pending')
            .then(response => {
                setPendingTrades(response.data);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching pending trades:', error);
            });
    }

    useEffect(fetchPendingTrades, []);

    const closeModal = () => {
        setSelectedTrade(null);
        setModalLoading(false);
        // Close the modal
        const modal = document.getElementById('tradeModal');
        if (modal) {
            const modalInstance = bootstrapBundleMin.Modal.getInstance(modal);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
    };

    const executeTrade = () => {
        setModalLoading(true);
        api.post('/api//v2/transactions/trade/execute', {
            tradeTime: selectedTrade.time
        }).then(() => {
            alert('Trade executed successfully! You may need to manually update Yahoo rosters.');
            fetchPendingTrades();
            closeModal();
        }).catch(error => {
            console.error('Error executing trade:', error);
            alert('Failed to execute trade. Please try again later.');
        });
    };

    const rejectTrade = () => {
        setModalLoading(true);
        api.post('/api/v2/transactions/trade/reject', {
            tradeTime: selectedTrade.time
        }).then(() => {
            alert('Trade rejected successfully.');
            fetchPendingTrades();
            closeModal();
        }).catch(error => {
            console.error('Error rejecting trade:', error);
            alert('Failed to reject trade. Please try again later.');
        });
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <div>
            <h2>Pending Trades</h2>
            <div className="text-center mb-3">
                <NavLink to="/trade" className="btn btn-primary text-white">Make trade {'>'}</NavLink>
            </div>
            {pendingTrades.length > 0 ? (
                <div className="list-group">
                    {pendingTrades.map((pendingTrade) => (
                        <a
                            type="button"
                            onClick={() => setSelectedTrade(pendingTrade)}
                            data-bs-toggle="modal"
                            data-bs-target="#tradeModal"
                            className="list-group-item list-group-item-action"
                        >
                            <div>
                                <strong>Proposed By:</strong> {pendingTrade.proposedBy}
                            </div>
                            <div>
                                <strong>Assets Offered:</strong> {pendingTrade.pbAssets.join(', ')}
                            </div>
                            <div>
                                <strong>Manager 2:</strong> {pendingTrade.manager2}
                            </div>
                            <div>
                                <strong>Assets Requested:</strong> {pendingTrade.m2Assets.join(', ')}
                            </div>
                            <div>
                                <strong>Time:</strong> {new Date(pendingTrade.time).toLocaleString()}
                            </div>
                        </a>
                    ))}
                </div>
            ) : (
                <p>No pending trades at the moment.</p>
            )}
            <div className="modal fade" id="tradeModal">
                <div className="modal-dialog">
                    <div className="modal-content">
                        {modalLoading && <OverlayLoader />}
                        <div className="modal-header">
                            <h5 className="modal-title">Trade Details</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            {selectedTrade ? (
                                <div>
                                    <p><strong>Proposed By:</strong> {selectedTrade.proposedBy}</p>
                                    <p><strong>Assets Offered:</strong> {selectedTrade.pbAssets.join(', ')}</p>
                                    <p><strong>Manager 2:</strong> {selectedTrade.manager2}</p>
                                    <p><strong>Assets Requested:</strong> {selectedTrade.m2Assets.join(', ')}</p>
                                    <p><strong>Time:</strong> {new Date(selectedTrade.time).toLocaleString()}</p>
                                </div>
                            ) : (
                                <p>Select a trade to view details.</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-success" onClick={executeTrade}>Accept</button>
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Decline</button>
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PendingTrades;